import HeaderToolbar from 'src/shared/components/navigations/headerToolbar';
import PageContainer from 'src/shared/components/organisms/pageContainer';
import ToastConfigure from 'src/shared/components/organisms/toastConfigure';

import { CssBaseline, Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import SideMenuMember from 'src/shared/components/navigations/side-menu/sideMenuMember';

export const MemberLayout = () => {
  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <HeaderToolbar />
      <SideMenuMember />
      <PageContainer>
        <Outlet />
      </PageContainer>
      <ToastConfigure />
    </Box>
  );
};
